<template> 
  <modal :value="value"
         max-width="600"
         content-class="sms-plan-credit-confirm-modal modal-device"
         :has-padding="false"
         @input="emitInput">        

    <div class="sms-add-plan-credit-confirm-modal-body">
      <div class="sms-add-plan-credit-confirm-modal-body-header">
        <button class="sms-add-plan-credit-confirm-modal-body-header-back"
                type="button"
                @click="emitBack">
          <i class=" mdi mdi-arrow-left pointer"></i>
        </button>

        <h1 class="sms-add-plan-credit-confirm-modal-body-title">Adicionar créditos</h1>
      </div>

      <p>Ao vincular um plano, o usuário receberá créditos, deseja que eles sejam adicionados já neste mês?</p>

      <v-radio-group v-model="addCredits"
                     v-validate="'required'"
                     :error-messages="errors.collect('Envio')"
                     name="Envio"
                     class="sms-add-plan-credit-confirm-modal-body-radio"
                     row>

        <v-radio :label="`Sim`"
                 :value="true"></v-radio>

        <v-radio :label="`Não`"
                 :value="false"></v-radio>

      </v-radio-group>

      <v-card-actions class="sms-add-plan-credit-confirm-modal-body-actions">
        <button class="btn btn-extra-round btn-primary btn-stretch"
                @click="emitConfirmation">
          Confirmar
        </button>
      </v-card-actions>
    </div>
  </modal>  
</template>

<script>
import Modal from "@/components/generic/Modal";

export default {
  components: {Modal},
  data() {
    return {
      page: 0,
      plansList: [],
      selectedId: undefined,
      loading: false,
      addCredits: true,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  methods: {
    emitInput(value) {
      this.$emit("input", value);
    },
    emitBack() {
      this.$emit("back");
    },
    hidePlanModal() {
      this.emitInput(false);
    },
    showPlanModal() {
      this.emitInput(true);
    },
    emitConfirmation() {
      this.$emit("confirmed", this.addCredits);
    },
  },
};
</script>

<style lang="scss" scoped>
.sms-plan-credit-confirm-modal {
  .sms-add-plan-credit-confirm-modal-body {
    padding: 10px 20px;
    text-align: center;

    .sms-add-plan-credit-confirm-modal-body-header {
      position: relative;

      .sms-add-plan-credit-confirm-modal-body-header-back {
        position: absolute;
        font-size: 30px;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }

    .sms-add-plan-credit-confirm-modal-body-radio {
      justify-content: center;
    }

    .sms-add-plan-credit-confirm-modal-body-actions {
      display: flex;
      justify-content: center;
      .btn {
        width: 200px;
      }
    }
  }
}
</style>
